import { useTranslation } from 'react-i18next';
import coin from '@/assets/images/KitoCoin.webp';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import styles from './ItemCardCashbackPIll.module.scss';

interface ItemCardCashbackPillProps {
  cashbackAmount: number;
  unavailable?: boolean;
}

const ItemCardCashbackPill = ({ cashbackAmount, unavailable }: ItemCardCashbackPillProps) => {
  const { t } = useTranslation();
  const { currency } = useCurrency();
  const currencyKey = currency === 'SAR' ? 'SAR' : 'AED';
  return (
    <div className={`${styles.cashbackValue} ${unavailable && styles.unavailable}`}>
      <img className={styles.kitcon} src={coin} alt="Kitopi" />
      <p>
        {t(`menu.itemCardCashbackPill.earnCashback.${currencyKey}`)}{' '}
        <span data-testid="item-cashback-amount">{cashbackAmount.toFixed(2)}</span>
      </p>
    </div>
  );
};

export default ItemCardCashbackPill;
